/**
 * beforeRoutes -> array = rotas anteriores para criar links
 * selectedPage -> string = Página Selecionada
 * classColor -> string = string de cor customizada
 * image -> string para importar imagem que esteja dentro do diretório breadcrumb-images
 * ignoreBreadcrumb -> bool = para ignorar o breadcrumb e importar apenas a imagem
 * ignoreMgBot -> bool = para ignorar a margem default do componente
 */
import React from "react";
import { Link } from "react-router-dom";
import './Breadcrumb.css'
import getImage from "../../useFull/getImage";


const Breadcrumb = (props) => {

    const { selectedPage, beforeRoutes, classColor, image, ignoreBreadcrumb, ignoreMgBot } = props
    const textClass = `breadcrumb-arrow ${classColor ? classColor : 'gray300'}`


    const img = getImage('breadcrumb-images', image);

    const bcrumb = () => {
        if(ignoreBreadcrumb) return
        return (
            <div className={`main-container ${img && 'breadcrumb-gradient'}`}>
                <div className="section-container">
                    <div className="container-breadcrumb" style={{
                        ...(ignoreMgBot ? {marginBottom: 0} : {})
                    }}>
                        {beforeRoutes.map((d, i) => {
                            return (<div key={i}>
                                {d.disabled ?
                                    <span className={textClass} >{`${d.label}`}</span> :
                                    <Link to={d.value} className={`${textClass} breadcrumb-link`}>{`${d.label}`}</Link>}
                                <span className={textClass}>{` > `}</span>
                            </div>
                            )

                        })}
                        <span className={`${textClass} selected-page`}>{selectedPage}</span>
                    </div>
                </div>
            </div>
        )
    }


    return (
        <>
            {img ? (
                <div className="breadcrumb-image" style={{ backgroundImage: `url(${img})` }}>
                    {bcrumb()}
                </div>
            ) : bcrumb()}


        </>
    )

}

export default Breadcrumb